import { deserialize } from 'cerialize'
import { ReceivingFileModel, ShortDataModel, PartnerTypeModel, ProductShortInfoModal } from 'Models'
import { ManagerModel } from 'Pages/auth'
import { InitialOrderModel, ProductUnBlockRequestModel } from 'Pages/orders'
import { ChannelModel } from 'Pages/referenceBooks'

export class UnBlockRequestModel {
	@deserialize public id: number
	@deserialize public created_at: string
	@deserialize public partner: {
		id: number
		name: string
		vat_number: string
		email: string
	}
	@deserialize public order_partner: any
	@deserialize public status: {
		code: string
		name: string
	}
	@deserialize public comment: string
	@deserialize public files: ReceivingFileModel[]
	@deserialize public manager: ShortDataModel
	@deserialize public author: ShortDataModel
	@deserialize public client_company_name: string
	@deserialize public client_inn: string
	@deserialize public order_id: number
	@deserialize public client_orders_count: number
	@deserialize public actions: {
		confirm: boolean
		decline: boolean
		clarify: boolean
	}
	@deserialize public rbidos: boolean
	@deserialize public initial_order_partner: {
		address_notification: any
		channels: ChannelModel[]
		id: number
		is_active: boolean
		manager: ManagerModel
		merchant_id: number
		name: string
		rbidos: boolean
		partner_type: PartnerTypeModel
		vat_number: string
	}
	@deserialize public initial_order: InitialOrderModel
	@deserialize public order: InitialOrderModel
	@deserialize public initial_order_partner_request: {
		id: number
		status: string
		last_agent_comment: string
		last_tmpp_comment: string
		files: ReceivingFileModel[]
		order_agreement_id: string
	}
	@deserialize public permissions: {
		back_to_checking: boolean
	}
	@deserialize public products?: ProductShortInfoModal[]
	@deserialize public order_products?: ProductUnBlockRequestModel[]
	@deserialize public initial_order_products?: ProductUnBlockRequestModel[]
}
